<!--
  @Description: 
  @Author: wang.y 
  @Date: 2024-01-30 
-->
<template>
  <div class="container">
    <div class="container-top">
      <div class="title">
        <img src="~img/logo/vb100.png" />
        <p>小程序券码核销系统</p>
      </div>
      <Button @click="$router.go(-1)">返回</Button>
    </div>
    <div class="theme-title">
      <span class="spa1">{{$route.query.name}}</span>
      <span class="spa2">核销操作</span>
    </div>
    <div class="theme-select">
      <div :class="['select-item', validStatus == 1 && 'error']">
        <div class="select-title">券码或手机号</div>
        <Input ref="code-input" v-model="ticketCode" placeholder="请输入券码或者手机号" @on-enter="writeofforder(ticketCode)" @on-change="validStatus = 0" />
        <div class="error-info">请输入券码或者手机号</div>
      </div>
      <Button type="primary" @click="writeofforder(ticketCode)" :loading="cancelLoading">验证券码</Button>
      <Button type="primary" @click="findticketbymobile" :loading="mloading">手机号搜索</Button>
    </div>
    <div class="main-container">
      <div class="lt">
        <Spin fix v-if="cancelLoading">
          <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
          <div>Loading</div>
        </Spin>
        <template v-if="cancelDetail.id">
          <div class="ticket-item">
            <div :class="['cancel-status', 'code' + cancelDetail.verificationMessageCode]">
              <div class="font" v-html="filter.dealNeed(cancelDetail.verificationMessageCode, msgArr)"></div>
              <div class="time">{{cancelDetail.createTime}}</div>
            </div>
            <div class="cancel">
              <p>
                <span class="spa1">核销码：</span>
                <span>{{cancelDetail.verificationCode}}</span>
              </p>
              <p>
                <span class="spa1">操作：</span>
                <span>{{cancelDetail.verificationUserName}}</span>
              </p>
            </div>
          </div>
          <div class="detail">
            <div class="row">
              <div class="col">
                <div class="th">票务信息</div>
              </div>
              <div class="col">
                <div class="th">订单信息</div>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <span class="spa1">门票：</span>
                <span class="spa2">{{cancelDetail.activityTicketTitle}}</span>
              </div>
              <div class="col">
                <span class="spa1">订单号：</span>
                <span class="spa2">{{cancelDetail.orderNumber}}</span>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <span class="spa1">类型：</span>
                <span class="spa2">{{ cancelDetail.ticketType | dealNeed(ticketTypes)}}</span>
              </div>
              <div class="col"></div>
            </div>
            <div class="row">
              <div class="col">
                <span class="spa1">参会人：</span>
                <span class="spa2">{{ cancelDetail.name}}</span>
              </div>
              <div class="col">
                <span class="spa1">购票人：</span>
                <span class="spa2">{{ cancelDetail.orderXuserName }}</span>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <span class="spa1">公司：</span>
                <span class="spa2">{{ cancelDetail.compName }}</span>
              </div>
              <div class="col">
                <span class="spa1">公司：</span>
                <span class="spa2">{{ cancelDetail.orderXuserCompName }}</span>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <span class="spa1">职务：</span>
                <span class="spa2">{{ cancelDetail.title }}</span>
              </div>
              <div class="col">
                <span class="spa1">职务：</span>
                <span class="spa2">{{ cancelDetail.orderXuserTitle }}</span>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <span class="spa1">电话：</span>
                <span class="spa2">{{ cancelDetail.mobile }}</span>
              </div>
              <div class="col">
                <span class="spa1">电话：</span>
                <span class="spa2">{{ cancelDetail.orderXuserMobile }}</span>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <span class="spa1">绑定时间：</span>
                <span class="spa2">{{ cancelDetail.bindingTime }}</span>
              </div>
              <div class="col">
                <span class="spa1">下单时间：</span>
                <span class="spa2">{{ cancelDetail.orderBuyTime }}</span>
              </div>
            </div>
          </div>
        </template>
        <div class="none" v-else>
          <div class="error" v-html="filter.dealNeed(cancelDetail.verificationMessageCode, msgArr)" v-if="cancelDetail.verificationMessageCode"></div>
          <p class="tip" v-else>请扫码或者输入券码核销</p>
        </div>
      </div>
      <div class="rt">
        <div class="table-top">
          <div class="number">
            <span class="spa1">已核销：</span>
            <span class="spa2">{{total}}</span>
            <span class="spa3">人</span>
          </div>
          <div>
            <Select v-model="listParam.sortType" style="width:100px" size="small" @on-change="handleChangeSort">
              <Option :value="1">倒序</Option>
              <Option :value="2">正序</Option>
            </Select>
          </div>
        </div>
        <div class="table-container">
          <Table :columns="recordColumns" :data="list">
            <template slot-scope="{ row }" slot="name">
              <a class="hover-a" @click="lookDetail(row.id)">{{row.name}}</a>
            </template>
            <template slot-scope="{ row }" slot="ticketType">
              {{row.ticketType | dealNeed(ticketTypes)}}
            </template>
          </Table>
          <div class="table-page" v-if="total > 10">
            <Page :total="total" :page-size="10" class="page-list" show-total show-elevator :current="listParam.page" @on-change="handleChangePage" />
          </div>
        </div>
      </div>
    </div>
    <audio ref="error-mp3" preload="auto">
      <source src="~img/error.mp3" type="audio/mpeg">
    </audio>
    <cancelDetailModal ref="cancelDetailModal"></cancelDetailModal>
    <Modal class="message-modal" width="760" v-model="detailModal2" title="门票列表" :footer-hide="true" :scrollable="true">
      <Table :columns="ticketColumns" :data="showTicketList">
        <template slot-scope="{ row }" slot="ticketType">
          {{row.ticketType | dealNeed(ticketTypes)}}
        </template>
        <template slot-scope="{ row }" slot="status">
          <span v-if="row.id" style="color: #f60">已核销</span>
          <span v-else>未核销</span>
        </template>
        <template slot-scope="{ row }" slot="action">
          <Button type="primary" v-if="!row.id" size="small" @click="writeofforder(row.verificationCode)" :loading="cancelLoading">核销</Button>
        </template>
      </Table>
      <div class="table-page" style="margin-top: 20px">
        <Page :total="ticketList.length" :page-size="5" class="page-list" show-total show-elevator :current="ticketPage" @on-change="changeTicketPage" />
      </div>
    </Modal>
  </div>
</template>
<script>
import { writeofforder, recordlist, findticketbymobile } from '@/service/main.js'
import cancelDetailModal from '@/components/cancelDetail'
import filter from '@/assets/js/filter'
export default {
  inject: ['handlePrint'],
  components: {
    cancelDetailModal,
  },
  created() {
    this.printStatus = this.$route.query.printStatus
    this.getRecordlist()
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs['code-input'].focus()
    })
  },
  data() {
    return {
      mloading: false,
      filter,
      ticketCode: '',
      cancelDetail: {},
      ticketTypes: [
        { id: 1, name: '付费票' },
        { id: 2, name: '免费票' },
        { id: 3, name: '赠送票' },
        { id: 4, name: '第三方售卖' },
      ],
      listParam: {
        activityId: this.$route.params.id,
        page: 1,
        size: 10,
        sortType: 1,
      },
      recordColumns: [
        {
          title: '核销序号',
          width: 70,
          key: 'id',
        },
        {
          title: '姓名',
          width: 70,
          slot: 'name',
        },
        {
          title: '手机号',
          width: 100,
          key: 'mobile',
        },
        {
          title: '票种',
          width: 130,
          key: 'activityTicketTitle',
        },
        {
          title: '类型',
          width: 80,
          slot: 'ticketType',
        },
        {
          title: '核销时间',
          width: 140,
          key: 'createTime',
        },
        {
          title: '操作人',
          minWidth: 70,
          key: 'verificationUserName',
        },
      ],
      ticketColumns: [
        {
          title: '姓名',
          width: 120,
          key: 'name',
        },
        {
          title: '票种',
          minWidth: 150,
          key: 'activityTicketTitle',
        },
        {
          title: '类型',
          width: 100,
          slot: 'ticketType',
        },
        {
          title: '核销状态',
          width: 100,
          slot: 'status',
        },
        {
          title: '操作',
          minWidth: 70,
          slot: 'action',
        },
      ],
      list: [],
      total: 0,
      msgArr: [
        { id: 1, name: '核销成功' },
        { id: 2, name: '门票错误<br/>非本论坛票' },
        { id: 3, name: '已被核销' },
      ],
      validStatus: 0,
      cancelLoading: false,
      ticketList: [],
      ticketPage: 1,
      detailModal2: false,
      printStatus: 0
    }
  },
  computed: {
    showTicketList() {
      return this.ticketList.slice((this.ticketPage - 1) * 5, this.ticketPage * 5)
    }
  },
  methods: {
    async findticketbymobile() {
      if (!this.ticketCode) {
        this.validStatus = 1
        return
      }
      if (this.mloading) {
        this.$Message.error('请勿重复操作')
        return
      }
      this.mloading = true
      let res = await findticketbymobile({
        activityId: this.$route.params.id,
        mobile: this.ticketCode
      })
      this.mloading = false
      if (res.code == 0) {
        this.$set(this.$data, 'ticketList', res.data)
        this.ticketPage = 1
        this.detailModal2 = true
      } else {
        this.$Message.error(res.msg)
      }
    },
    changeTicketPage(value) {
      this.ticketPage = value
    },
    async writeofforder(value) {
      if (!value) {
        this.validStatus = 1
        return
      }
      if (this.cancelLoading) {
        this.$Message.error('请勿重复操作')
        return
      }
      this.cancelLoading = true
      let res = await writeofforder({
        activityId: this.$route.params.id,
        verificationCode: value,
      })
      this.ticketCode = ''
      this.$refs['code-input'].focus()
      this.cancelLoading = false
      this.detailModal2 = false
      if (res.code == 0) {
        this.$set(this.$data, 'cancelDetail', res.data)
        if (res.data.verificationMessageCode == 1) {
          this.handleChangePage(1)
          if(this.printStatus == 1) this.handlePrint(res.data.verificationCode, res.data.name)
        } else {
          this.$refs['error-mp3'].play()
        }
      } else {
        this.$Message.error(res.msg)
      }
    },
    async getRecordlist() {
      let res = await recordlist(this.listParam)
      if (res.code == 0) {
        this.$set(this.$data, 'list', res.data.writeOffRecordDtoList)
        if (this.listParam.page == 1) this.$set(this.$data, 'total', res.data.count)
      } else {
        this.$Message.error(res.msg)
      }
    },
    handleChangePage(value) {
      this.listParam.page = value
      this.getRecordlist()
    },
    handleChangeSort(value) {
      this.listParam.sortType = value
      this.listParam.page = 1
      this.getRecordlist()
    },
    lookDetail(rowId) {
      this.$refs['cancelDetailModal'].getDetail(rowId)
    },
  },
}
</script>
<style lang='stylus' scoped>
.message-modal
  >>>.ivu-modal-mask
    background-color rgba(0, 0, 0, 0.6)
  >>>.ivu-modal-wrap
    display flex
    align-items center
    justify-content center
  >>>.ivu-modal
    top auto
    .ivu-modal-content
      background #ffffff
      border-radius 0
    .ivu-modal-header-inner
      color #333
      font-size 20px
      font-weight 600
      height 36px
      line-height 36px
    .ivu-modal-close
      top 16px
      .ivu-icon-ios-close
        color #333
        font-size 38px
        &:hover
          color #2c66d2
    .ivu-modal-header
      border-bottom none
      padding 20px
    .ivu-modal-body
      padding 0 20px 40px
.container
  width 1200px
  min-height 100vh
  margin 0 auto
  padding-top 50px
  .container-top
    display flex
    align-items center
    .title
      img
        width 90px
        height 25px
      p
        font-size 20px
        font-weight 500
        color #B3B5B5
        line-height 1
        margin-top 12px
    .ivu-btn-default
      width 60px
      height 35px
      border 2px solid #333333
      border-radius 6px
      font-size 16px
      font-weight bold
      color #333333
      padding 0
      margin-left 40px
  .theme-title
    font-size 30px
    font-weight bold
    line-height 44px
    margin-top 30px
    .spa1
      color #2E6BF7
    .spa2
      color #333333
      margin-left 10px
  .theme-select
    display flex
    align-items center
    margin-top 30px
    .ivu-btn-primary
      width 160px
      height 60px
      background linear-gradient(90deg, #2765F6, #6E99FC)
      border-radius 10px
      margin-left 20px
      font-size 20px
      font-weight bold
      color #FFFFFF
    .select-item
      position relative
      .select-title
        position absolute
        height 16px
        font-size 16px
        color #333333
        line-height 1
        padding 0 6px
        background #fff
        z-index 2
        top -7px
        left 30px
      .error-info
        color #ff0000
        position absolute
        font-size 16px
        line-height 24px
        bottom -24px
        opacity 0
      &.error
        .error-info
          opacity 1
        >>> .ivu-input
          border-color #ff0000
    >>> .ivu-input-wrapper
      width 400px
      .ivu-input
        border-color #CCC
        height 60px
        font-size 18px
        padding 10px 30px
        &:focus
          border-color #2765F6
          background-color #f9fdff
.main-container
  margin-top 40px
  display flex
  .lt
    flex 0 0 510px
    max-width 510px
    min-width 510px
    min-height 580px
    background #FCFCFC
    border 1px solid #6794FC
    padding 40px 20px
    position relative
    .ticket-item
      display flex
      align-items center
      > div
        flex 0 0 214px
        max-width 214px
        min-width 214px
        &+div
          margin-left 10px
          flex 0 0 244px
          max-width 244px
          min-width 244px
    .cancel
      white-space nowrap
      .spa1
        font-weight bold
        color #2E6BF7
    .cancel-status
      &.code1
        color #51C332
      &.code2, &.code3
        color #FC3B3B
      .font
        font-size 46px
        font-weight bold
        line-height 1
      .time
        font-size 16px
        margin-top 10px
    .detail
      margin-top 20px
      .row
        display flex
        > .col
          flex 0 0 214px
          max-width 214px
          min-width 214px
          display flex
          white-space nowrap
          &+.col
            margin-left 10px
            flex 0 0 244px
            max-width 244px
            min-width 244px
        &+.row
          margin-top 20px
      .th
        font-size 16px
        font-weight bold
        color #333333
        position relative
        padding-left 8px
        line-height 1
        line-height 18px
        &::before
          content ''
          position absolute
          width 4px
          height 16px
          background linear-gradient(270deg, #2765F6, #6E99FC)
          border-radius 2px
          left 0
          top 0
      .spa1
        color #666666
        font-weight bold
        word-break keep-all
      .spa2
        color #333333
        font-weight bold
        word-break break-word
    .none
      .error
        font-size 46px
        font-weight bold
        line-height 1.5
        text-align center
        color #FC3B3B
      .tip
        text-align center
        color #999
  .rt
    margin-left 20px
    flex 0 0 670px
    max-width 670px
    min-width 670px
    .table-top
      display flex
      align-items center
      justify-content space-between
      .number
        .spa1
          color #2E6BF7
          font-size 14px
        .spa2
          color #FC3B3B
          font-size 30px
        .spa3
          color #333
          font-size 14px
    .table-container
      margin-top 16px
      >>> .ivu-table-wrapper
        width 100%
        .hover-a
          color #2E6BF7
          cursor pointer
    .table-page
      margin-top 20px
      text-align center
</style>